import React from "react";

import { Button } from "@fluentui/react-components";
import { useAtom, useAtomValue } from "jotai";
import { devices } from "library/constants";
import { useBenefitPaymentsData } from "pages/Dashboard/hooks/useBenefitPaymentsData";
import { useTranslation } from "react-i18next";
import { selectedClientAtom } from "store";
import { selectedBenefitCurrencyAtom } from "store/index";
import styled from "styled-components";

import { Flex, StyledTooltip } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import useEmployee from "hooks/useEmployee";
import { useSetDefaultBenefitCurrency } from "hooks/useSetDefaultBenefitCurrency";

export function BeneficCurrencySelect() {
  useSetDefaultBenefitCurrency();
  const { t } = useTranslation();
  const theme = useAppTheme();
  const [selectedCurrency, setSelectedCurrency] = useAtom(selectedBenefitCurrencyAtom);
  const paymentData = useBenefitPaymentsData();
  const { employeeData } = useEmployee();
  const selectedClient = useAtomValue(selectedClientAtom);

  const payments = paymentData.rawPayments || {};
  const currencyList = Object.keys(payments).map((keyAsCurrency) => {
    return keyAsCurrency;
  });

  const singleCurrency = currencyList.length === 1;

  return (
    <Container>
      <Title>
        {t("hbh.greeting.label", {
          name: employeeData?.firstName || "",
        })}
      </Title>
      <StyledTooltip
        relationship="label"
        content={{
          children: selectedClient?.messageToEmployees ?? t("hbh.welcome.label"),
        }}
      >
        <Subtitle>{selectedClient?.messageToEmployees ?? t("hbh.welcome.label")}</Subtitle>
      </StyledTooltip>
      {singleCurrency ? null : (
        <Flex $justify="flex-end">
          <Flex>
            {currencyList.map((currency) => {
              return (
                <Button
                  size="small"
                  appearance="subtle"
                  style={{
                    color: selectedCurrency === currency ? theme.palette.purpleDark : "inherit",
                    fontWeight: selectedCurrency === currency ? 800 : 400,
                  }}
                  onClick={() => {
                    setSelectedCurrency(currency);
                  }}
                  key={currency}
                >
                  {currency}
                </Button>
              );
            })}
          </Flex>
        </Flex>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  gap: 10px;

  flex-direction: column;
  margin-bottom: 20px;
`;
const Title = styled.h1`
  font-weight: 600;
  font-size: 18px;
  margin: 0;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media only screen and ${devices.md} {
    font-size: 24px;
    line-height: 30px;

    max-width: 700px;
  }
`;

const Subtitle = styled.h2`
  max-width: 1200px;
  font-weight: 400;
  font-size: 14px;
  margin: 0;
  @media only screen and ${devices.md} {
    font-size: 18px;
  }
`;
